<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/live-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">一站式私域电商直播解决方案</div>
        <div class="sub-title">全渠道引流，品牌推广，直播互动营销，加速交易<br>转化，打造线上线下一体化电商直播闭环</div>
      </div>
      <img src="@/assets/Mobile/images/solution/live01.png" alt="">
    </div>
    <div class="block02">
      <div class="page-mobile-title">
        <div class="title">直播预告分享 蓄水前置流量</div>
        <div class="sub-title">通过直播预热精准锁客，促进销售转化</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/live02.png" alt="">
          <span class="title">直播好货预告</span>
          <span class="text">提前预热 提前锁客</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/live03.png" alt="">
          <span class="title">营销海报分享</span>
          <span class="text">多渠道传播曝光直播信息</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/live04.png" alt="">
          <span class="title">微信小程序邀约</span>
          <span class="text">触达微信好友 朋友圈</span>
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="page-mobile-title">
        <div class="title">轻松卖货 全方位展示商品</div>
        <div class="sub-title">直播中通过管理商品方便用户快速成交供应链能力<br>灵活叠加，丰富直播商品库</div>
      </div>
      <div class="content">
        <div class="item">
          <img class="image02" src="@/assets/Mobile/images/solution/live05.png" alt="">
          <span class="title">讲解中商品 首页主推</span>
          <span class="text">商品排序、推荐展示商品</span>
        </div>
        <div class="item">
          <img class="image02" src="@/assets/Mobile/images/solution/live06.png" alt="">
          <span class="title">手动推荐展示热销商品</span>
          <span class="text">商品排序、推荐展示商品</span>
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="page-mobile-title">
        <div class="title">多种营销玩法 提升粉丝参与感、提高销售转化</div>
        <div class="sub-title">红包（口令红包）、拉新、抽奖、点赞、秒杀等</div>
      </div>
      <div class="content">
        <div class="item">
          <img class="image03" src="@/assets/Mobile/images/solution/live07.png" alt="">
          <span class="title">花样玩法 根本停不下来</span>
          <span class="text">直播中串联多种营销活动</span>
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="page-mobile-title">
        <div class="title">为远程服务场景赋能</div>
        <div class="sub-title">直播作为基础服务平台，为更多远程场景提供便利服务</div>
      </div>
      <div class="content">
        <div class="item">
          <img class="image04" src="@/assets/Mobile/images/solution/live08.png" alt="">
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="page-mobile-title">
        <div class="title">多渠道代播、直播代运营服务</div>
        <div class="sub-title">抖音、快手等多渠道代播、直播代运营服务，<br>解决不懂直播运营，不会播，没人播的困扰</div>
      </div>
      <div class="content">
        <div class="item">
          <img class="image05" src="@/assets/Mobile/images/solution/live09.png" alt="">
        </div>
      </div>
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">汇好看直播产品矩阵</div>
      </div>
      <div class="content" />
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">汇好看直播平台的优势</div>
      </div>
      <img src="@/assets/Mobile/images/solution/live11.png" alt="">
    </div>
    <div class="block05">
      <div class="sk-mobile-title">
        <div class="title">直播赋能，提升转化效果</div>
      </div>
      <img src="@/assets/Mobile/images/solution/live12.png" alt="">
    </div>
    <Case title="直播电商" />
    <ContactForm info-sources="直播电商" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.LiveBroadcast,
  components: {
    ContactForm,
    IndustrySolution,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  background-color: #FAFAFA;
  img {
    width: 348px;
    margin: 20px 0;
  }
}
.page-mobile-title {
  padding-top: 30px;
  .title {
    font-size: 17px;
    font-weight: 600;
    color: #6862F6;
    line-height: 24px;
  }
  .sub-title {
    font-size: 13px;
    font-weight: 400;
    color: #595961;
    line-height: 26px;
  }
}
.block02 {
  background-color: #FAFAFA;
  .content {
    display: flex;
    justify-content: space-evenly;
    margin-top: 30px;
    .item {
      display: flex;
      flex-direction: column;
      img {
        width: 119px;
      }
      .title {
        font-size: 8px;
        font-weight: 500;
        color: #595961;
        line-height: 15px;
      }
      .text {
        font-size: 7px;
        font-weight: 400;
        color: #595961;
        line-height: 15px;
      }
    }
  }
}
.image02 {
  width: 124px !important;
}
.image03 {
  width: 214px !important;
}
.image04 {
  width: 220px !important;
}
.image05 {
  width: 269px !important;
  margin-bottom: 21px;
}
.block03 {
  height: 250px;
  background: linear-gradient(182deg, #9531F2 0%, #382370 100%);
  // opacity: 0.85;
  .title {
    color: #fff;
  }
  // img {
  //   width: 342px;
  //   margin-top: 20px;
  // }
  .content {
    width: 342px;
    height: 143px;
    background: url("~@/assets/Mobile/images/solution/live10.png") no-repeat;
    background-size: 100%;
    margin: 20px auto 0;
  }
}
.block04 {
  height: 294px;
  background-color: #FAFAFA;
  img {
    width: 342px;
    margin-top: 27px;
  }
}
.block05 {
  height: 262px;
  img {
    width: 338px;
    margin-top: 20px;
  }
}
</style>
